import React from 'react';
import PlansCard from './PlansCard';

export default function PlanSetting() {
  return <PlansCard />;
}
